import * as React from 'react';

import {
    Alert,  
    Divider,
    Drawer,
    notification,
    Progress,
    Row,
} from 'antd';
import { L } from '../../../lib/abpUtility';
import { NoteSummaryDto } from '../../../services/dto/summaries/noteSummaryDto';
import { NoteTypes } from '../../EntityConfigs/noteTypes';
import NotesView from '../../Controls/Widgets/notesView';
import {  CommentOutlined,  } from '@ant-design/icons';
import { NotificationDto } from '../../../services/dto/entities/notificationDto';
import { RcFile, UploadChangeParam } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';


export interface IDashboardProps {
    currentNotifications: NotificationDto[];
    visible: boolean;
    onCancel: () => void;
    primaryColor: string;
    secondaryColor: string;
    currentProfileImage: any;
    defaultImage: string;
    currentState: any;
    commentFilter(id: any): void;
    commentSearch(filter: any): void;
    commentDataSummary: any[];
    defaultIcon: any;
    commentsLoading: boolean; 
    currentUserID: any;
    currentUserName: any;
    fileList: Array<any>;
    title: string;
    subTitle: string;
    search_Mentions: any;
    search_Hashtags: any;
    defaultType: any;
    commentAdd(input: NoteSummaryDto): void;
    commentDelete(id: number): void;
    getFile(id: number): any;
    getUserProfileImage: (id: any) => any;

    removeFile: (file: UploadFile) => void;
    commentAdd(input: NoteSummaryDto): void;
    commentDelete(id: number): void;

    addFile: (file: RcFile) => any; 
    filesLoading: boolean;
    intialFilesList: Array<UploadFile>;
}

export interface IItemBaseState {
    currentProfileImage: string;
    prefix: any;
    fieldNameSize: any;
    activeAccordianKey: any;
    fileListLoading: boolean;
    previewVisible: boolean;
    previewURL: string;
    imgLoading: boolean;
}

export class Dashboard extends React.Component<IDashboardProps, IItemBaseState> {


    state = {
        currentProfileImage: '',
        prefix: '@',
        fieldNameSize: '0.8em',
        activeAccordianKey: NoteTypes.Feed,
        fileListLoading: false,
        previewURL: '',
        previewVisible: false,
        imgLoading: false,
    };


    //-----------------------------------------------------------------
    // Form Clear/Complete Methods
    //-----------------------------------------------------------------
    handleFinish = (values: any) => {
        this.props.onCancel();
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    handleSearch(e: any) {


    };

    onSearch = (_: any, prefix: any) => {
        this.setState({ prefix: prefix });
    };


    //-----------------------------------------------------------------
    // Image / File Methods
    //-----------------------------------------------------------------


    async uploadFile(file: RcFile) {
        this.setState({ fileListLoading: true });
        let result = await this.props.addFile(file);
        this.setState({ fileListLoading: false });
        return result.url;
    }

    async getFile(info: UploadFile<any>) {


        this.setState({ fileListLoading: true });
        let result = await this.props.getFile(Number(info.uid));

        const isJpgOrPng = info.type === 'image/jpeg' || info.type === 'image/png';
        if (!isJpgOrPng) {
            const link = document.createElement('a');
            link.href = result.url;
            link.target = '_blank';
            link.setAttribute('download', result.name,);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        else {

            this.setState({ previewURL: result.url })
            this.setState({ previewVisible: true })
        }

        this.setState({ fileListLoading: false })

        return;

    }

    async getBase64(img: any, callback: any) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    beforeFileUpload(file: RcFile, fileList: RcFile[]) {

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            notification.open({
                message: L('Uh Oh!'),
                description:
                    L('Image must be smaller than 2MB')
            });
        }
        return isLt2M;
    }
 
    handleFileChange = (info: UploadChangeParam<UploadFile<any>>) => {

        if (info.file.status === 'uploading') {
            //this.setState({ fileListLoading: true });
            return;
        }
        else {

            if (info.file.originFileObj !== undefined) {
                // Get this url from response in real world.
                this.getBase64(info.file.originFileObj, (imageUrl: any) =>
                    this.setState({
                        fileListLoading: false,
                    }),
                );
            }

        }

    };

    //-----------------------------------------------------------------


    render() {
 


        return (

            <Drawer className="font-face-gm" closeIcon={false} closable={false}
                width={window.innerWidth < 600 ? (window.innerWidth * 0.9) : 450}
                placement="right" onClose={this.props.onCancel}
                open={this.props.visible}  >
                <Divider className="font-face-gm" type="horizontal"
                    style={{ fontSize: '2.1em', marginBottom: '0px', }} >
                    <div style={{ fontSize: '0.6em', marginBottom: '-10px' }}>{this.props.title}</div>
                    {L('Activity')}

                </Divider>
                <Row style={{ marginBottom: '0px' }}>
                    <Progress
                        strokeColor={{
                            from: this.props.secondaryColor,
                            to: this.props.primaryColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                    />
                </Row>

                <div style={{
                    margin: 'auto', float: 'none', marginBottom: '10px', textAlign: 'center', marginTop: '10px',
                }}>

                    {this.props.currentNotifications.map((x: NotificationDto) => {
                        return <div style={{ marginBottom: '5px' }}><Alert className="font-face-gm" style={{ fontSize: '1.1em' }} message={x.message} type={x.type} showIcon closable /></div>;
                    })}

                </div>



                <div style={{
                            margin: 'auto', float: 'none',
                            marginBottom: '10px', textAlign: 'center', fontSize: '0.9em'
                        }}>


                            <NotesView
                                getUserProfileImage={(e: any) => this.props.getUserProfileImage(e)}
                                enableSearch={true}
                                search_Hashtags={this.props.search_Hashtags}
                                search_Mentions={this.props.search_Mentions}
                                currentUserName={this.props.currentUserName}
                                currentUserID={this.props.currentUserID}
                                primaryColor={this.props.primaryColor}
                                secondaryColor={this.props.secondaryColor}
                                isMobile={false}
                                loading={this.props.commentsLoading}
                                dataTableImage={<CommentOutlined style={{ fontSize: '50px', marginTop: '10px' }} />}
                                dataTableText={L('No Activity')}
                                showHeader={false}
                                dataSummary={this.props.commentDataSummary}
                                commentAdd={this.props.commentAdd}
                                handleSearch={this.props.commentSearch}
                                commentFilter={this.props.commentFilter}
                                commentDelete={this.props.commentDelete}
                            />

                        </div>
 








            </Drawer>

        );
    }
}

export default Dashboard;
